import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'gb-empty-state-date',
  templateUrl: './gb-empty-state-date.component.html',
  styleUrls: ['./gb-empty-state-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbEmptyStateDateComponent {}
